module.exports = __webpack_public_path__ + "img/learnModel-Pic1.fbae2335.png";